/**
 * Enum representing categories for GA4.
 */
export enum categoryName {
  USER_TYPE = 'user_type',
  PRINT = 'print',
  EXPORT = 'export',
  FORM_SUBMISSION = 'form_submission',
  TICKET_LIST = 'ticket_list',
  TICKET_IMAGES = 'ticket_images',
  TICKET_DOCUMENTS = 'ticket_documents',
  TICKET_DETAIL = 'ticket_detail',
  USER_MANAGEMENT = 'user_management',
  SUPPLIER_SETTINGS = 'supplier_settings',
  USER_SETTINGS = 'user_settings',
  SUPPLIER_CONSUMER_MAPPING = 'supplier_consumer_mapping',
}

/**
 * Enum representing events for GA4.
 */
export enum eventName {
  IS_INTERNAL_USER = 'is_internal_user',
  PRINT_TICKET_DETAIL = 'print_ticket_detail',
  VIEW_TICKET_DETAIL = 'view_ticket_details',
  VIEW_IMAGES = 'view_images',
  VIEW_TRUCKSCALE_IMAGES = 'view_truckscale_images',
  VIEW_OTHER_IMAGES = 'view_other_images',
  VIEW_DOCUMENT = 'view_documents',
  TICKET_CSV_EXPORT = 'ticket_csv_export',
  TICKET_EXCEL_EXPORT = 'ticket_excel_export',
  TICKET_DOC_EXPORT = 'ticket_document_export',
  CREATE_USER = 'create_user',
  EDIT_USER = 'edit_user',
  ACTIVATE_USER = 'activate_user',
  DEACTIVATE_USER = 'deactivate_user',
  CHANGE_ROLE = 'change_role',
  SAVE_SUPPLIER_SETTINGS = 'save_supplier_settings',
  SAVE_USER_SETTINGS = 'save_user_settings',
  RESET_SUPPLIER_SETTINGS = 'reset_supplier_settings',
  RESET_USER_SETTINGS = 'reset_user_settings',
  SYNC_WITH_SD = 'sync_with_sd',
  ADD_SUPPLIERS_CONSUMERS = 'add_suppliers_consumers',
  CHANGE_PARENT = 'change_parent',
  MARK_AS_PARENT = 'mark_as_parent',
  MAP_TO_PARENT = 'map_to_parent',
  MARK_AS_UNASSIGNED = 'mark_as_unassigned',
  REMOVE_PARENT = 'remove_parent',
  SUPPORT_FORM = 'support_form',
  CONTACT_SUPPORT_FORM = 'contact_support_form',
}

/**
 * Enum representing metrices for GA4.
 */

export enum metricsName {
  NO_OF_TICKETS_VIEWED = 'no_of_tickets_viewed',
  NO_OF_IMAGES_VIEWED = 'no_of_images_viewed',
  NO_OF_IMAGES_DOWNLOAD = 'no_of_images_downloaded',
  NO_OF_DOCUMENTS_VIEWED_DOWNLOAD = 'no_of_documents_viewed_downloaded',
}
